<template>
  <div class="home">
    <PurchasingDetailList />
  </div>
</template>

<script>
// @ is an alias to /src
import PurchasingDetailList from '@/components/purchasing/PurchasingDetailList.vue'

export default {
  name: 'PurchsaingDetailList',
  components: {
    PurchasingDetailList
  },
  mounted () {
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getCompanyList')
  }
}
</script>
